/**
 * Api services for pages module
 */
import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';

/**
 * Api services for page component
 */
export const pagesService = {
  savePage,
  getPages,
  getPagById,
  updatePage,
  deletePage,
};

function savePage(data) {
  return Observable.create((observer) => {
    fetch(
      config.api_url + config.url.pages + (data.params ? data.params : ''),
      {
        method: 'POST',
        headers: {
          Authorization: data.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data.data),
      }
    )
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error);
        }
      });
  });
}
function getPages(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.pages + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getPagById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.pages + data.id, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function updatePage(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.pages + data.data.pageData.pageUid, {
      method: 'PUT',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error);
        }
      });
  });
}
function deletePage(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.pages + data.id, {
      method: 'DELETE',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
